import { render, staticRenderFns } from "./queue-list.vue?vue&type=template&id=961b173c&"
import script from "./queue-list.vue?vue&type=script&lang=js&"
export * from "./queue-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports